// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { gql } from '@apollo/client';
export type HypotheticalTransferUtils_EntityFragment = { __typename?: 'Entity', id: string, extendedDisplayKind: string, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } };

export type HypotheticalTransferUtils_ClientProfileFragment = { __typename?: 'ClientProfile', id: string, displayName: string };

export type HypotheticalTransferUtils_EstateWaterfallHypotheticalTransferFragment = { __typename?: 'EstateWaterfallHypotheticalTransfer', id: string, sourceKind: Types.EstateWaterfallHypotheticalTransferSourceKind, destinationKind: Types.EstateWaterfallHypotheticalTransferDestinationKind, name?: string | null, transferTaxKind: Types.EstateWaterfallHypotheticalTransferTransferTaxKind, transferValue?: CurrencyUSD | null, taxableValue?: CurrencyUSD | null, startYear?: number | null, endYear?: number | null, sourceEntity?: (
    { __typename?: 'Entity' }
    & HypotheticalTransferUtils_EntityFragment
  ) | null, sourceIndividual?: (
    { __typename?: 'ClientProfile' }
    & HypotheticalTransferUtils_ClientProfileFragment
  ) | null, destinationEntity?: (
    { __typename?: 'Entity' }
    & HypotheticalTransferUtils_EntityFragment
  ) | null, destinationIndividual?: (
    { __typename?: 'ClientProfile' }
    & HypotheticalTransferUtils_ClientProfileFragment
  ) | null, destinationOrganization?: { __typename?: 'ClientOrganization', id: string, name: string } | null };

export const Operations = {
  Fragment: {
    HypotheticalTransferUtils_Entity: 'HypotheticalTransferUtils_Entity' as const,
    HypotheticalTransferUtils_ClientProfile: 'HypotheticalTransferUtils_ClientProfile' as const,
    HypotheticalTransferUtils_EstateWaterfallHypotheticalTransfer: 'HypotheticalTransferUtils_EstateWaterfallHypotheticalTransfer' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const HypotheticalTransferUtils_EntityFragmentDoc = gql`
    fragment HypotheticalTransferUtils_Entity on Entity {
  id
  extendedDisplayKind
  subtype {
    id
    displayName
  }
}
    `;
export const HypotheticalTransferUtils_ClientProfileFragmentDoc = gql`
    fragment HypotheticalTransferUtils_ClientProfile on ClientProfile {
  id
  displayName
}
    `;
export const HypotheticalTransferUtils_EstateWaterfallHypotheticalTransferFragmentDoc = gql`
    fragment HypotheticalTransferUtils_EstateWaterfallHypotheticalTransfer on EstateWaterfallHypotheticalTransfer {
  id
  sourceKind
  sourceEntity {
    ...HypotheticalTransferUtils_Entity
  }
  sourceIndividual {
    ...HypotheticalTransferUtils_ClientProfile
  }
  destinationKind
  destinationEntity {
    ...HypotheticalTransferUtils_Entity
  }
  destinationIndividual {
    ...HypotheticalTransferUtils_ClientProfile
  }
  destinationOrganization {
    id
    name
  }
  name
  transferTaxKind
  transferValue
  taxableValue
  startYear
  endYear
}
    ${HypotheticalTransferUtils_EntityFragmentDoc}
${HypotheticalTransferUtils_ClientProfileFragmentDoc}`;